import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'pbc-search24',
  templateUrl: './search24.component.html',
})
export class Search24Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
